import { capitalCategoricalPalette } from "../../capitalCategoricalPalette.js";
const MuiScatterChart = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
export {
  MuiScatterChart
};
//# sourceMappingURL=MuiScatterChart.js.map
